import { Link, useLocation } from "react-router-dom";
import { useState, useEffect } from "react";
import { useCart } from "../views/cart/CartContext";
import { fetchProductCategories } from "../services/menuService";
import "./TopMenu.css";

const TopMenu = () => {
  const [menuItems, setMenuItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const location = useLocation();
  const { cartState } = useCart();

  const isAuthPage =
    location.pathname === "/account/signin" || location.pathname === "/account/signup";

      useEffect(() => { 
        const isReloaded = sessionStorage.getItem("isReloadedTopMenu");
        if (!isReloaded) {
          sessionStorage.setItem("isReloadedTopMenu", "true");
          window.location.reload();
        }
        return () => {
          sessionStorage.removeItem("isReloadedTopMenu");
        };// need to improve and in fucture in use single useEffect
      }, [location.key]);

  useEffect(() => {
    getCategories();
  }, []);

  const getCategories = async () => {
    try {
      const data = await fetchProductCategories();
      const formattedData = data.map((category) => {
        if (typeof category === "string") {
          return category;
        } else if (typeof category === "object" && category.name) {
          return category.name;
        } else {
          console.warn("Skipping invalid category:", category);
          return null;
        }
      });
      setMenuItems(formattedData);
    } catch (error) {
      setError(error.message);
    } finally {
      setLoading(false);
    }
  };

  if (isAuthPage) return null;

  return (
    <nav className="navbar navbar-expand-lg navbar-dark bg-dark p-0">
      <div className="container-fluid">
        {/* Left Side: Categories */}
        <button
          className="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarSupportedContent"
          aria-controls="navbarSupportedContent"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon" />
        </button>
        <div className="collapse navbar-collapse" id="navbarSupportedContent">
          <ul className="navbar-nav">
            {loading && <li className="nav-item">Loading...</li>}
            {error && <li className="nav-item text-danger">{error}</li>}
            {!loading &&
              !error &&
              menuItems.map((item, index) => {
                if (typeof item !== "string") {
                  return null;
                }
                return (
                  <li className="nav-item" key={index}>
                    <Link className="nav-link" to={`/category/${item}`}>
                      {item.charAt(0).toUpperCase() + item.slice(1)}
                    </Link>
                  </li>
                );
              })}
            {!loading && !error && menuItems.length === 0 && (
              <li className="nav-item">No categories available</li>
            )}
          </ul>
        </div>

        {/* Right Side: Cart and Profile */}
        <div className="d-flex ms-auto align-items-center">
          <div className="position-relative me-3">
            <Link to="/cart" className="btn btn-primary">
              <i className="bi bi-cart3"></i>
              {cartState.cartItems.length > 0 && (
                <div className="cart-badge">
                  {cartState.cartItems.length}
                </div>
              )}
            </Link>
          </div>

          <div className="btn-group">
            <button
              type="button"
              className="btn btn-secondary rounded-circle border"
              data-bs-toggle="dropdown"
              aria-expanded="false"
              aria-label="Profile"
            >
              <i className="bi bi-person-fill text-light"></i>
            </button>
            <ul className="dropdown-menu dropdown-menu-end">
              <li>
                <Link className="dropdown-item" to="/account/profile">
                  <i className="bi bi-person-square"></i> My Profile
                </Link>
              </li>
              <li>
                <Link className="dropdown-item" to="/star/zone">
                  <i className="bi bi-star-fill text-warning"></i> Star Zone
                </Link>
              </li>
              <li>
                <Link className="dropdown-item" to="/account/orders">
                  <i className="bi bi-list-check text-primary"></i> Orders
                </Link>
              </li>
              <li>
                <Link className="dropdown-item" to="/account/wishlist">
                  <i className="bi bi-heart-fill text-danger"></i> Wishlist
                </Link>
              </li>
              <li>
                <hr className="dropdown-divider" />
              </li>
              <li>
                <Link className="dropdown-item" to="/account/notification">
                  <i className="bi bi-bell-fill text-primary"></i> Notification
                </Link>
              </li>
              <li>
                <Link className="dropdown-item" to="/support">
                  <i className="bi bi-info-circle-fill text-success"></i> Support
                </Link>
              </li>
              <li>
                <hr className="dropdown-divider" />
              </li>
              <li>
                <Link className="dropdown-item" to="/account/signin">
                  <i className="bi bi-box-arrow-in-right text-primary"></i> Sign In
                </Link>
              </li>
              <li>
                <Link className="dropdown-item" to="/">
                  <i className="bi bi-box-arrow-right text-danger"></i> Logout
                </Link>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default TopMenu;
